import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType } from "../../Components/navigationTypes"
export const workspaceList: Array<MenuItemType> = [
    {
        label: "Due Diligence",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Property Online",
                appCode: ["RPWNS"],
                navigate: {
                    component: "",
                    url: "http://novascotia.ca/sns/access/land/property-online.asp",
                },
                addOptions: [],
                type: MenuItemCategory.WindowOpen,
            },
            {
                label: "ISC Property Search",
                appCode: ["RPWSK"],
                navigate: {
                    component: "",
                    url: "https://www.isc.ca/SignedInHome/Pages/login.aspx",
                },
                addOptions: [],
                type: MenuItemCategory.WindowOpen,
            },
            {
                label: "Title Search",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 3,   
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Title Search",
                appCode: ["RPWSK", "RPWNS", "RPWAB", "RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "TitleSearchButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "LTSA",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "LTSAButton"
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TitleInsurance
            },
            {
                label: "Manufactured Home",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "ManufacturedHomeButton"
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TitleInsurance
            },
            {
                label: "First Nations Land",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "FirstNationsLandButton"
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TitleInsurance
            },
            {
                label: "Archived Searches",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "oldSearch"
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TitleInsurance
            },
            {
                label: "Writ Search",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Similiar Names",
                appCode: ["RPW", "RPWAB", "RPWNS"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 0,
                    },
                    reactFrame: 'similiarnames',
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Tax Search",
                appCode: ["RPWSK"],
                navigate: null,
                addOptions: [],
                type: MenuItemCategory.Dropdown,
                dropdownOptions: [
                    {
                        label: "Moose Jaw",
                        navigate: {
                            component: "",
                            url: "https://moosejaw.ca/property-tax-assessment-search/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Regina",
                        navigate: {
                            component: "",
                            url: "http://www.regina.ca/residents/assessment/tax-property-search",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Saskatoon",
                        navigate: {
                            component: "",
                            url: "https://www.saskatoon.ca/services/property-tax-searches-certificates",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                ]
            },
            {
                label: "Tax Search",
                appCode: ["RPW"],
                navigate: null,
                addOptions: [],
                type: MenuItemCategory.Dropdown,
                dropdownOptions: [
                    {
                        label: "Burlington",
                        navigate: {
                            component: "",
                            url: "https://www.burlington.ca/en/property-taxes/tax-certificates.aspx",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Cambridge",
                        navigate: {
                            component: "",
                            url: "https://online.cambridge.ca/WaterService/taxinfo.aspx",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Markham",
                        navigate: {
                            component: "",
                            url: "https://www.markham.ca/wps/portal/Markham/MunicipalGovernment/PropertyTaxes/tax-certificates/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Mississauga",
                        navigate: {
                            component: "",
                            url: "https://www.mississauga.ca/portal/services/purtaxcertificate",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Oakville",
                        navigate: {
                            component: "",
                            url: "http://www.oakville.ca/residents/taxes-statements.html",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Ottawa",
                        navigate: {
                            component: "",
                            url: "https://myservice.ottawa.ca/profile/account/login?lang=en",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Toronto",
                        navigate: {
                            component: "",
                            url: "https://www.toronto.ca/services-payments/property-taxes-utilities/tax-utility-certificate-service/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Windsor Tax Search",
                        navigate: {
                            component: "",
                            url: "https://apps.citywindsor.ca/eti/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Windsor Tax Assessment",
                        navigate: {
                            component: "",
                            url: "https://publicpropertyinquiry.citywindsor.ca/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                ],
            },
            {
                label: "Tax Search",
                appCode: ["RPWAB"],
                navigate: null,
                addOptions: [],
                type: MenuItemCategory.Dropdown,
                dropdownOptions: [
                    {
                        label: "Calgary",
                        navigate: {
                            component: "",
                            url: "https://cityonline.calgary.ca/col_ccu/property-information/5637145378.c",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Edmonton",
                        navigate: {
                            component: "",
                            url: "http://taxcertificates.edmonton.ca/",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Lethbridge",
                        navigate: {
                            component: "",
                            url: "https://ecom.lethbridge.ca/MyCity/PIP/Pages/Login.aspx?templateName=DEFAULT",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Medicine Hat",
                        navigate: {
                            component: "",
                            url: "https://www1.medicinehat.ca/login.aspx",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Okotoks",
                        navigate: {
                            component: "",
                            url: "https://vth.okotoks.ca/default.aspx",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                    {
                        label: "Redcliff",
                        navigate: {
                            component: "",
                            url: "https://my.townofredcliff.ca:8443/VCH/city/mycity/login.aspx?ReturnUrl=%2fVCH%2fcity%2fmycity%2fmycity.aspx",
                        },
                        addOptions: [],
                        type: MenuItemCategory.WindowOpen,
                    },
                ],
            },
            {
                label: "Tax Search",
                appCode: ["RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                        autoClick: "TaxSearchButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading,
    },
    {
        label: "Title Insurance",
        PSM: "PM",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Title Insurance",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Title Insurance",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TitleInsurance
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Requisition",
        label: "Requisition",
        appCode: ["RPW"],
        PSM: "PS",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Requisition",
                appCode: ["RPW"],
                PSM: "P",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Response to Requisition",
                appCode: ["RPW"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Undertaking",
        label: "Undertaking",
        appCode: ["RPWBC"],
        PSM: "PSM",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Undertaking",
                appCode: ["RPWBC"],
                PSM: "PM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 1,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Response to Undertaking",
                appCode: ["RPWBC"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 1,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Description",
        label: "Description",
        appCode: ["RPWAB"],
        PSM: "PM",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Description",
                appCode: ["RPWAB"],
                PSM: "PM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "TrustLetter",
        label: "Trust Letter",
        appCode: ["RPWAB"],
        PSM: "S",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Response to Trust Letter",
                appCode: ["RPWAB"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "TrustLetterMB",
        label: "Trust Letter",
        appCode: ["RPWMB"],
        PSM: "PS",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Trust Letter",
                appCode: ["RPWMB"],
                PSM: "P",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }, {
                label: "Response to Trust Letter",
                appCode: ["RPWMB"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "TrustLetterSK",
        label: "Trust Letter",
        appCode: ["RPWSK"],
        PSM: "PS",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Trust Letter Reconciliation",
                appCode: ["RPWSK"],
                PSM: "P",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }, {
                label: "Trust Letter",
                appCode: ["RPWSK"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Objection",
        label: "Objection",
        appCode: ["RPWNS"],
        PSM: "PSM",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Objection",
                appCode: ["RPWNS"],
                PSM: "PM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }, {
                label: "Response to Objection",
                appCode: ["RPWNS"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "TitleMemorandum",
        label: "Title Memorandum",
        appCode: ["RPW", "RPWSK", "RPWAB", "RPWMB"],
        PSM: "M",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [

            {
                label: "Title Memorandum",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        label: "Registration",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Registration Details",
                appCode: ["RPW", "RPWAB", "RPWSK", "RPWNS"],
                navigate: {
                    component: "main",
                    action: "PopUpRegistrationDetails"
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Teranet",
                appCode: ["RPWMB"],
                navigate: {
                    component: "main",
                    action: "openTeranetPopup",
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "PIPS",
                appCode: ["RPW"],
                PSM: "P",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 0,
                    },
                    reactFrame: 'PIPS',
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Export to E-Reg",
                symbol: "trademark",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 0,
                    },
                    reactFrame: 'ereg',
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "LOTR",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Registrations",
                        tabNumber: 0
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Web Filing",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Registrations",
                        tabNumber: 1
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Matters",
        label: "Issues",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: "Issues",
                tabNumber: 0,
                autoClick: "SearchIssues",
            },
            //action: "AddNewDefectSearch"
        },
        subItems: [
            {
                label: "All Issues",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 0,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Checklist",
                appCode: ["RPW", "RPWSK", "RPWNS", "RPWAB", "RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 3,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Checklist",
                appCode: ["RPWBC"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Inquiry Status",
                appCode: ["RPW", "RPWSK", "RPWNS", "RPWAB", "RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 1,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Inquiry Status",
                appCode: ["RPWBC"],
                PSM: "PM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 3,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Report",
                PSM: "PS",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Report",
                PSM: "M",
                appCode: ["RPWNS"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            /*{
                label: "Title Memorandum",
                PSM:"M",
                appCode: ["RPWMB", "RPWSK"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Trust Letter",
                appCode: ["RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Trust Letter",
                appCode: ["RPWSK"],
                PSM:"S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Trust Letter Reconciliation",
                appCode: ["RPWSK"],
                PSM:"P",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },*/
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    }
]